/**
 * Where Supabase sends the user back after an email confirmation, magic link,
 * password reset or OAuth round-trip (mobile assessment §H.2, §A.3 row 1).
 *
 * The website derived this from window.location.origin, which inside the
 * Android WebView is https://localhost — a URL no email can open. The origin
 * now comes from the platform: the page's own origin on the web, the
 * configured App Link origin natively, so a tapped link opens the app.
 */
import { platform } from '@/platform';

export function authRedirectOrigin(): string {
  return platform.authRedirectOrigin();
}

/** `${origin}${path}`, carrying the current ?redirect= through (the pre-existing behaviour). */
export function buildAuthRedirectUrl(path: string, search: string = typeof window === 'undefined' ? '' : window.location.search): string {
  const redirectParam = new URLSearchParams(search).get('redirect');
  const baseUrl = `${authRedirectOrigin()}${path}`;
  return redirectParam ? `${baseUrl}?redirect=${encodeURIComponent(redirectParam)}` : baseUrl;
}
